<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <span style="font-size: 24px">表单模版</span>
      <div class="head-text" style="float: right">
        <el-input
          placeholder="请输入"
          class="search-input"
          style="width: 300px"
          v-model="searchword"
        ></el-input>
        <el-button
          slot="append"
          icon="el-icon-search"
          class="mar-t80"
          @click="GetFormTempList"
        ></el-button>
        <el-button type="primary" @click="showAddForm(null)">新增</el-button>
      </div>
    </div>

    <el-table height="72vh" align="center" class="table" :data="formTemplist">
      <el-table-column
        align="center"
        prop="fmtp03"
        label="模版名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="创建人"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="fmtp06"
        label="创建时间"
      ></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            @click="showAddForm(scope.row.fmtp01)"
            size="small"
            type="primary"
            plain
            >编辑</el-button
          >
          <el-popconfirm
            @confirm="DelOneFormTemp(scope.row.fmtp01)"
            title="确定删除吗？"
            style="margin-left:10px"
          >
            <el-button slot="reference" size="small" type="danger" plain
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      align="center"
      class="mar-top20"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageIndex"
      :page-sizes="[100, 50, 10]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 新增 -->

    <el-drawer
      :with-header="false"
      title="我是标题"
      :visible.sync="addFormShow"
      direction="ttb"
      size="100%"
      :before-close="handleClose"
    >
      <el-descriptions class="margin-top" :column="3" border>
        <el-descriptions-item>
          <template slot="label"> 选择文件 </template>
          <el-upload
            :auto-upload="false"
            class="upload-demo"
            action="/"
            :on-change="handleChange"
            :on-remove="handRemove"
          >
            <el-button slot="trigger" size="small" type="primary"
              >导入Excel/world</el-button
            >
            <el-button
              style="margin-left: 10px"
              size="small"
              type="success"
              @click="submitUpload"
              >上传到服务器</el-button
            >

            <div slot="tip" class="el-upload__tip">
              只能上传导入Excel/world文件
            </div>
          </el-upload>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 模版名称 </template>
          <el-input
            style="width: 200px"
            v-model="eab_formtemp.fmtp03"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label"> 操作 </template>
          <el-button size="small" @click="AddOrUpdateFormTemp">保存</el-button>
        </el-descriptions-item>
      </el-descriptions>

      <el-row style="height: 90%">
        <el-col :span="12" style="height: 100%; overflow: auto">
          <el-descriptions
            v-for="(item, index) in tempFields"
            :key="index"
            class="margin-top"
            :column="3"
            border
          >
            <el-descriptions-item>
              <template slot="label"> 表单变量 </template>
              <el-button style="width: 100px" type="text">
                {{ item.fmfd06 }}
              </el-button>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 类型指定 </template>
              <el-select v-model="item.fmfd04" placeholder="请选择">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 指定可编辑权限 </template>
              <el-select v-model="item.fmfd05" placeholder="请选择">
                <el-option
                  v-for="item in typeOptions2"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
          </el-descriptions>
        </el-col>
        <el-col :span="12" style="height: 100%; overflow: auto">
          <iframe
            v-if="eab_formtemp.fmtp05"
            :src="this.$store.state.baseUrl + eab_formtemp.fmtp05"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
        </el-col>
      </el-row>
    </el-drawer>
  </el-card>
</template>

<script>
import {
  AddOrUpdateFormTemp,
  GetOneFormTemp,
  GetFormTempList,
  DelOneFormTemp,
} from "@/setAxios";
export default {
  data() {
    return {
      addFormShow: false,
      fd: new FormData(),
      eab_formtemp: {
        fmtp01: 0,
        fmtp02: localStorage.xid,
        fmtp03: "",
        fmtp04: "",
        fmtp05: "",
        fmtp06: "",
        fmtp07: localStorage.id,
      },
      tempFields: [],
      formTemplist: [],
      total: 0,
      searchword: "",
      pageIndex: 1,
      pageSize: 15,
      typeOptions: [
        {
          value: 1,
          label: "文本",
        },
        {
          value: 2,
          label: "日期时间",
        },
        {
          value: 3,
          label: "地址",
        },
        {
          value: 4,
          label: "电话号码",
        },
        {
          value: 5,
          label: "金额",
        },
        {
          value: 6,
          label: "是否选择项",
        },
        {
          value: 7,
          label: "人员",
        },
        {
          value: 8,
          label: "印章",
        },
        {
          value: 9,
          label: "签名",
        },
        {
          value: 10,
          label: "视点",
        },
        {
          value: 11,
          label: "选择集",
        },
        {
          value: 12,
          label: "图片",
        },
      ],
      typeOptions2: [
        {
          value: 1,
          label: "发起人",
        },
        {
          value: 2,
          label: "审核人",
        },
      ],
    };
  },
  created() {
    this.GetFormTempList();
  },
  methods: {
    handRemove() {
      this.fd.delete("file");
    },
    showAddForm(id) {
      if (id) {
        this.GetOneFormTemp(id);
      } else {
        this.eab_formtemp = {
          fmtp01: 0,
          fmtp02: localStorage.xid,
          fmtp03: "",
          fmtp04: "",
          fmtp05: "",
          fmtp06: "",
          fmtp07: localStorage.id,
        };
        this.tempFields = [];
      }
      this.addFormShow = true;
    },
    async AddOrUpdateFormTemp() {
      let fd = new FormData();
      fd.append("formtemp", JSON.stringify(this.eab_formtemp));
      fd.append("tempfield", JSON.stringify(this.tempFields));
      fd.append("qid", localStorage.pid);
      let res = await AddOrUpdateFormTemp(fd);
      if (res.Code) {
        this.$message.success("保存成功");
      }
    },
    async GetFormTempList() {
      let params = {
        xid: localStorage.xid,
        searchword: this.searchword,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      let res = await GetFormTempList({ params });
      this.total = res.Data.total;
      this.formTemplist = res.Data.list;
    },
    async GetOneFormTemp(id) {
      let params = {
        id,
      };
      let res = await GetOneFormTemp({ params });
      this.eab_formtemp = res.Data.formTemp;
      this.tempFields = res.Data.tempFields;
    },
    async DelOneFormTemp(id) {
      let params = {
        id,
      };
      let res = await DelOneFormTemp(params);
      if (res.Code) {
        this.$message.success("删除成功");
        this.GetFormTempList();
      }
    },
    async submitUpload() {
      this.eab_formtemp.fmtp06 = new Date();
      this.fd.append("formtemp", JSON.stringify(this.eab_formtemp));
      this.fd.append("tempfield", JSON.stringify(null));
      this.fd.append("qid", localStorage.pid);
      let res = await AddOrUpdateFormTemp(this.fd);

      if (res.Code) {
        this.$message.success("添加模本成功");
        this.eab_formtemp = res.Data.formTemp;
        this.tempFields = res.Data.tempFields;
      }
    },
    handleClose() {
      this.$confirm("确定关闭？").then((_) => {
        this.addFormShow = false;
        this.GetFormTempList();
      });
    },
    handleChange(file) {
      this.fd.append("file", file.raw);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetFormTempList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetFormTempList();
    },
  },
};
</script>

<style scoped></style>
